import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(list)/audits-for-company',
)({
  component: lazyRouteComponent(
    () => import('../../../-components/AuditsForCompanyLayout'),
    'AuditsForCompanyLayout',
  ),
});
